export default __webpack_public_path__ + "static/trackthebat1-b66397d0cff7f9864ce488001bc497a4.png";